import React from 'react';
import { Box } from '@pinwheel/origami';
var Divider = function (_a) {
    var style = _a.style;
    return (React.createElement(Box, { sx: {
            width: '100%',
            height: '1px',
            minHeight: '1px',
            backgroundColor: {
                type: 'theme',
                colorLegacy: 'Neutral/70',
                colorNext: 'neutral/default',
            },
            opacity: 0.15,
            margin: '0 0 24px 0',
        }, style: style }));
};
export default Divider;
